module.exports = __webpack_public_path__ + "static/media/jhsm.fb7d7307.png";